module.exports = __webpack_public_path__ + "img/close.5045da7c.png";